export default {
  free: 'ILMAINEN',
  save: 'Säästä {{amount}}',
};
